import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultInterstitialCTA = _resolveComponent("ResultInterstitialCTA")!

  return (_ctx.isSearchResultItem)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resultType), {
        key: 0,
        result: _ctx.result,
        index: _ctx.itemIndex,
        defaultSiteImageUrl: _ctx.defaultSiteImageUrl
      }, null, 8, ["result", "index", "defaultSiteImageUrl"]))
    : (_openBlock(), _createBlock(_component_ResultInterstitialCTA, {
        key: 1,
        result: _ctx.result
      }, null, 8, ["result"]))
}